import { createAsyncThunk } from '@reduxjs/toolkit';
import { IPlannedInterviewsByFullDate } from 'src/api/base/Interviews/types';
import { InterviewApi } from 'src/api/base/Interviews';

export const fetchUpcomingInterviews = createAsyncThunk(
  'upcomingInterviews/fetchInterviews',
  async (): Promise<IPlannedInterviewsByFullDate[]> => {
    const response = await InterviewApi.getUpcomingInterviews();
    return response.data.data;
  },
);
